<div class="row">
    <div class="col-sm-12">
    <div  class="card sign-in-forms">
    <div class="text-center mt-5">
        <i class="fa fa-user fa-4x"></i>
    </div>
    <h5 class="card-header text-center">{{registeredUser.username}}</h5>
    <h6 class="card-header text-center">Create a password to complete your account creation</h6>
    <div class="card-body">
        <div class="alert alert-danger text-center" *ngIf="responseMessage!=''">
            {{responseMessage}}
        </div>

        <form [formGroup]="form" (ngSubmit)="onSubmit()">


            <div class="form-group input-group-lg">

                <input placeHolder="Password" type="password" formControlName="password" class="form-control" [ngClass]="{ 'is-invalid': f.password.errors && f.password.touched }" />
                <div *ngIf="f.password.errors && f.password.touched" class="invalid-feedback">
                    <div *ngIf="f.password.errors.required">Password is required</div>
                </div>
            </div>
            <div class="form-group input-group-lg mt-3">

                <input placeHolder="Password Confirmation" type="password" formControlName="passwordConfirmation" class="form-control" [ngClass]="{ 'is-invalid': f.passwordConfirmation.errors && f.passwordConfirmation.touched }" />
                <div *ngIf="f.passwordConfirmation.errors && f.passwordConfirmation.touched" class="invalid-feedback">
                    <div *ngIf="f.passwordConfirmation.errors.required">Password Confirmation is required</div>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-sm-12 text-center  mt-2">
                  By Creating an account, you agree to
                    <a [routerLink]="['/info/usage/policy']">Terms of Use</a> and
                    <a [routerLink]="['/info/privacy/policy']">Privacy Policy</a>
                </div>
            </div>
            <div class="form-group row input-group-lg">
                <div class="col-sm-6 offset-sm-3 mt-2">
                <button [disabled]="loading" class="btn btn-primary btn-lg btn-block">
                    <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
                    Continue  <i class = "fa fa-chevron-circle-right "></i>
                </button>
            </div>
            </div>
        </form>
    </div>
</div>
</div>
</div>

